import React, { useEffect, useState } from "react";

interface ISecondQuestionProps {
  value: string;
  text: string;
  setValue: (value: string) => void;
}

/** Display second question */
const SecondQ = ({
  value,
  text,
  setValue,
}: ISecondQuestionProps): JSX.Element => {
  const [answer, setAnswer] = useState("");

  useEffect(() => {
    if (value !== null) setAnswer(value);
  }, [value]);

  return (
    <section className="second-section">
      <h2 className="second-header">{text}</h2>
      <textarea
        onChange={(e) => setAnswer(e.target.value)}
        value={answer}
        rows={3}
        id="type_input"
        className="second-input"
        tabIndex={0}
        placeholder="Type your answer here..."
      />
      {!!answer && (
        <button
          className="orange-button"
          tabIndex={0}
          type="button"
          onClick={() => setValue(answer)}
        >
          OK
        </button>
      )}
    </section>
  );
};
export default SecondQ;
